import React from 'react'
import styled from 'styled-components'
import { Flex } from 'src/components/ui'

const InputContainer = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 8px;
  padding: 8px 8px 8px 10px;
  min-width: 600px;
  height: 48px;
  display: flex;
  border: 1.3px solid #0000001A;

  @media (max-width: ${(props) => props.theme.breakpoint.md}) {
    min-width: auto;
  }
  @media (max-width: ${(props) => props.theme.breakpoint.sm}) {
    padding: 10px;
    width: 100%;
  }

  &:focus-within {
    border: 1.3px solid #0000001A;
  }

  input {
    color: #717182;
    font-size: 14px;
    border: 0;
    outline: none;
    width: 100%;
    font-weight: 400;
    font-family: 'Arimo';

    &::placeholder {
      font-size: 14px;
      line-height: 30px;
      color: #717182;
      font-family: 'Arimo';
    }
  }
  img {
    width: 17px;
  }
`
interface Props {
  handleChange: (e: any) => void
  type?: string
  placeholder?: string
  icon: any
}

export const PartInput: React.FC<Props> = ({
  handleChange,
  placeholder = 'Search',
  type = 'text',
  icon,
  ...rest
}) => {
  return (
    <InputContainer>
      <Flex style={{ width: '100%'}}>
        {icon}
        <input {...rest} type={type} placeholder={placeholder} onChange={handleChange} />
      </Flex>
    </InputContainer>
  )
}

export default PartInput